module.exports = __webpack_public_path__ + "static/media/ae.0e568baa.svg";